import { getResults } from "../../../api"
import { DELETE, POST } from "../../../util/fetch-methods"

export const cancelValidation = () => {
    return getResults('/api/v1/users/verify/email/', DELETE())
}

export const resendValidation = () => {
    return getResults('/api/v1/users/verify/email/', POST())
}

export const validateLegacy = () => {
    return getResults('/api/v1/users/verify/account/', POST())
}
